var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{ref:"teamMemberModal",attrs:{"title":_vm.member?.name,"ok-only":"","size":"lg","modal-class":"bootstrap","content-class":"pr-3 pt-3","header-class":"d-flex"}},[(_vm.member)?_c(_setup.TeamMember,{attrs:{"member":_vm.member,"show-name":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }